import { combineReducers } from "redux";

const applyImageFilter = (state = {}, action) => {
    switch (action.type) {
        case "APPLY_IMAGE_FILTER_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_IMAGE_FILTER":
            return {};
        default:
            return state;
    }
};

const fetchUserFilteredImages = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_FILTERED_IMAGES_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchFilteredImages: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchFilteredImages: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    applyImageFilter,
    fetchUserFilteredImages,
});
